<template>
  <div>
    <div class="deliverySet-tips">说明:开启【配送到家】说明支持送货上门，需要社区店长将商品配送至用户家里哦</div>
    <div class="deliverySet-common flex-between">
      <span>配送到家</span>
      <van-switch
        :value="deliveryState"
        size="25px"
        @input="switchInput"
      />
    </div>
    <div
      class="deliverySet-common flex-between"
      v-show="deliveryState"
      @click="showScope = true;setObj.scope = scope;"
    >
      <span>配送距离</span>
      <span class="see-details">
        {{scope}}km
        <van-icon
          name="arrow"
          color="#999999"
        />
      </span>
    </div>
    <div class="deliverySet-explain">说明：{{deliveryState == 0 ?"已关闭配送到家服务":"已开启配送到家服务，用户若要求配送到家，社区店长需要配合将商品送至用户收货地址"}}</div>
    <!-- 配送距离弹窗 -->
    <van-dialog
      v-model="showScope"
      show-cancel-button
      confirmButtonColor="#FF453E"
      cancelButtonColor="#1D1D1D"
      :before-close="beforeClose"
    >
      <van-field
        type="tel"
        class="deliverySet-field"
        v-model="setObj.scope"
        label="配送距离:"
        placeholder="请输入送货上门范围"
        :formatter="formatter"
        :error-message="message"
        @input="onInput"
      >
        <template #button>
          km
        </template>
      </van-field>
    </van-dialog>
  </div>
</template>

<script>
import { shopInfo, updateShopInfo, setDeliveryState, getDeliveryState } from "@/api/join";
export default {
  data() {
    return {
      showScope: false,
      scope: "",
      setObj: {},
      message: "",
      deliveryState: false
    }
  },
  methods: {
    switchInput(checked) {
      this.$dialog.alert({
        title: checked == false ? "" : "开启配送到家",
        message: checked == false ? "是否确定关闭配送到家服务" : "社区店长需配合用户需求，将商品送至用户收货地址",
        confirmButtonText: checked == false ? "确定关闭" : "确定开启",
        confirmButtonColor: "#1993FF",
        cancelButtonText: "取消",
        cancelButtonColor: "#1D1D1D",
        showCancelButton: true,
      }).then(() => {
        this.getSetDeliveryState(checked);
      });
    },
    onInput(e) {
      // 限制范围[0,200]之间
      if (e > 200) {
        this.setObj.scope = e.slice(0, e.length - 1);
      }
    },
    formatter(value) {
      // 输入一位小数
      return value.replace(/[^\d.]/g, "").replace(/\.{2,}/g, ".").replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3");
    },
    beforeClose(action, done) {
      switch (action) {
        case 'confirm':
          if (this.setObj.scope * 1 < this.setObj.minScope * 1 || (this.setObj.scope == "" || this.setObj.scope == undefined)) {
            this.message = `最小配送距离不能低于${this.setObj.minScope}km`;
            done(false);
            return;
          }
          updateShopInfo(this.setObj).then((res) => {
            if (res.appStatus.errorCode == 0) {
              this.message = "";
              this.scope = this.setObj.scope;
              this.$toast("保存成功");
              done();
            }
          });
          break;
        case 'cancel':
          this.message = "";
          done()
          break;
      }
    },
    shopInfo() {
      shopInfo({}).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.setObj = res.content;
          this.scope = this.setObj.scope;
          this.getDeliveryState(this.setObj.communityShopId);
        }
      });
    },
    getSetDeliveryState(checked) {
      setDeliveryState({
        csId: this.setObj.communityShopId,//社区店长id
        deliveryState: checked == false ? "0" : "1" //配送到家状态 0-否 1-是
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.deliveryState = checked;
        }
      });
    },
    getDeliveryState(id) {
      getDeliveryState({
        csId: id,//社区店长id
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          //res.content.deliveryState 0-否 1-是
          this.deliveryState = res.content.deliveryState == 0 ? false : true;
        }
      });
    },
  },
  mounted() {
    this.shopInfo();
  }
}
</script>

<style lang="scss" scoped>
.deliverySet-tips {
  width: 345px;
  height: 41px;
  padding: 7px 15px;
  font-size: 15px;
  background-color: #ffe9d5;
  z-index: 1000;
}
.deliverySet-common {
  height: 50px;
  padding: 0 15px;
  font-size: 15px;
  background-color: #ffffff;
  .see-details {
    display: flex;
    align-items: center;
  }
}
.deliverySet-explain {
  padding: 10px 15px 0;
  font-size: 12px;
  color: #999999;
}
.deliverySet-field {
  padding: 30px 14px;
}
</style>
<style scoped>
.deliverySet-field >>> .van-field__label {
  width: auto;
  height: 40px;
  line-height: 40px;
  margin-right: 5px;
  font-size: 15px;
  color: #1d1d1d;
}
.deliverySet-field >>> .van-field__control {
  padding: 7px 5px;
  border: 1px solid #b4b4b4;
  border-radius: 5px;
}
.deliverySet-field >>> .van-field__button {
  font-size: 15px;
  color: #1d1d1d;
}
.deliverySet-field >>> .van-field__error-message {
  position: absolute;
  top: 40px;
  font-size: 11px;
  color: #fd3325;
  z-index: 1000;
}
</style>